import React from "react";
import Head from "next/head";
import cotributeDefaults from "@dreambigger/shared/src/assets/cotribute-defaults";

export interface HeadProps {
  favicon?: string;
  title?: string;
  description?: string;
  siteName?: string;
  image?: string;
  // When true, emit a <link rel="canonical"> pointing at the current
  // origin + pathname (query string stripped). This collapses UTM-tagged
  // campaign links and per-step query-param URLs back to one indexable URL
  // so search engines don't index them as duplicate pages. Opt-in because
  // this Head component is shared across apps.
  canonical?: boolean;
}

const CotributeHead: React.FC<HeadProps> = ({
  favicon,
  title,
  description,
  siteName,
  image,
  canonical,
}: HeadProps) => {
  const socialUrl =
    typeof globalThis.window !== "undefined"
      ? globalThis.window.location.href
      : "";
  // Pages are statically generated and served across many vanity hosts
  // (onboard.<fi>.org), so the absolute URL is only known client-side —
  // same constraint as og:url above. Strip query/hash via origin + pathname.
  const canonicalUrl =
    typeof globalThis.window !== "undefined"
      ? globalThis.window.location.origin + globalThis.window.location.pathname
      : "";

  return (
    <Head>
      {/* Mobile viewport. `initial-scale=1` keeps iOS Safari from loading
          the page partially zoomed (default `width=device-width` alone can
          render at fractional zoom on rotation/back-nav). */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, viewport-fit=cover"
      />
      <link
        rel="shortcut icon"
        type="image/x-icon"
        href={favicon || cotributeDefaults.tabIconIco}
      />
      <title>{title || cotributeDefaults.title}</title>
      <meta property="og:title" content={title || cotributeDefaults.title} />
      <meta
        property="og:description"
        content={description || cotributeDefaults.description}
      />
      <meta
        property="og:site_name"
        content={siteName || cotributeDefaults.name}
      />
      <meta property="og:image" content={image || cotributeDefaults.image} />
      <meta property="og:image:width" content="1600" />
      <meta property="og:image:height" content="800" />
      <meta property="og:url" content={socialUrl} />
      {canonical && canonicalUrl && (
        <link rel="canonical" href={canonicalUrl} />
      )}
      <meta property="og:type" content="website" />
      <meta
        property="fb_app:id"
        content={process.env.NEXT_PUBLIC_FB_ID || ""}
      />
    </Head>
  );
};

//NOTE: This is exported out of design-system under the alias "Head"
export default CotributeHead;
